import { Fragment, useState } from "react"
import { observer } from "mobx-react"
import parse from "react-html-parser"
import { useStore } from "@features/common"
import { SubscriptionForm } from "@features/subscription"
import { ButtonContained } from "@ui"
import OwlHarrySVG from "@assets/media/owl-harry.svg"

export type SubscriptionDialogProps = {
  success?: boolean
  onClose?: () => void
}

export const SubscriptionDialog = observer(function SubscriptionDialog(
  props: SubscriptionDialogProps,
) {
  const { GlobalModel, AnalyticsModel, ModalModel } = useStore()
  const { success = false, onClose } = props
  const [showSuccess, setShowSuccess] = useState<boolean>(success)

  const close = () => {
    ModalModel.close()
    if (onClose) {
      onClose()
    }
  }

  const submitForm = () => {
    setShowSuccess(true)
    AnalyticsModel.subscribePopUpSubmitClick()
  }

  return (
    <Fragment>
      <div
        data-test-id="subscription__modal_image"
        className="mt-[13.8vh] pb-12 w-full flex justify-center tablet-s:-mt-26"
      >
        <OwlHarrySVG />
      </div>
      {showSuccess ? (
        <div className="tablet-s:px-8 tablet-s:pb-[44px] px-4 ">
          <h5 className="mb-4 text-2xl text-center font-serif">
            {parse(
              GlobalModel.getTemplate("subscription.success.title", false),
            )}
          </h5>
          <p className="mb-6 text-lg text-center">
            {GlobalModel.getTemplate("subscription.success.message")}
          </p>
          <ButtonContained
            data-test-id="subscription__modal_success_button"
            className="w-full"
            onClick={close}
          >
            {GlobalModel.getTemplate("subscription.success.button")}
          </ButtonContained>
        </div>
      ) : (
        <SubscriptionForm onSubmit={submitForm} />
      )}
    </Fragment>
  )
})
